module.exports = __webpack_public_path__ + "img/small_whale10.63a725e9.jpg";